import React from 'react';
import { compose } from 'ramda';
import * as ReactDOM from 'react-dom';

import styleFile from './TooltipWrapper.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { showPopover } from '../../providers/popoverProvider.jsx';

import Tooltip from '../Tooltip';

const TooltipWrapper = class TooltipWrapper extends React.Component {
  static displayName = 'TooltipWrapper';
  constructor(props) {
    super(props);

    this.typeTooltip = this.props.config.typeTooltip || 'tooltip';
    this.state = {
      bindButton: null,
      deleteChildren: null,
      toggleChildren: null,
      setToggleChildren: null,
      timeout: null,
      tooltip: null,
      wrapperDOMElem: null,
      familyType: this.props.config.family || 'tooltip'
    };

    this.providerToggleTooltip = this.props.config.toggleModal;
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  isMobile = () => this.props.theme.uaDeviceType !== 'DESK';

  toggleTooltip = show => e => {
    if (e && !this.props.config.enablePropagation) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!this.props.config.disabled) {
      this.setState(state => {
        clearTimeout(state.timeout);
        if (show) {
          this.providerToggleTooltip(
            show,
            this.typeTooltip,
            state.tooltip,
            this.state.familyType,
            this.props.config.removeTooltipTimeout,
            this.isMobile()
          );
          const closeTimeout = this.props.config.autoCloseTimeout ?
            setTimeout(() => {
              this.providerToggleTooltip(
                false,
                this.typeTooltip,
                null,
                this.state.familyType,
                this.props.config.removeTooltipTimeout,
                this.isMobile()
              );
            }, this.props.config.autoCloseTimeout)
            : null;

          return {
            timeout: closeTimeout

          };
        } else {
          return {
            timeout: setTimeout(() => {
              this.providerToggleTooltip(
                show,
                this.typeTooltip,
                null,
                this.state.familyType,
                this.props.config.removeTooltipTimeout,
                this.isMobile()
              );
            }, 20)
          };
        }
      });
    }
  };

  forceCloseTooltip = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.providerToggleTooltip(false, this.typeTooltip, null, this.state.familyType, 0);
  };

  createTooltip = DOMElem => {
    const tooltip = this.props.config.popover;
    const { classes } = this.props.theme.styles;
    return (
      <Tooltip
        onlyCloseByButton={this.props.config.onlyCloseByButton}
        innerStyle={[this.props.config.popoverStyle || 'tooltipStyle']}
        parentRef={DOMElem}
        posX={this.props.config.posX}
        posY={this.props.config.posY}
        key={this.typeTooltip}
        bottomLimit={this.props.config.bottomLimit}
        toggleTooltip={this.toggleTooltip}
        pointerStyle={[this.props.config.pointerStyle, classes.pointerStyle].join(' ')}
        avoidPointer={this.props.config.avoidPointer}>
        {React.isValidElement(tooltip) ? tooltip : tooltip(this.toggleTooltip, this.forceCloseTooltip)}
      </Tooltip>
    );
  };

  callBackBindButton = elem => {
    this.setState(state => {
      let DOMElem = ReactDOM.findDOMNode(elem);
      const typeEvent = this.isMobile() ? 'click' : 'mouseenter';
      !this.props.config.disabled && DOMElem.addEventListener(typeEvent, this.toggleTooltip(true));
      !this.isMobile() && DOMElem.addEventListener('mouseleave', this.toggleTooltip(false));

      return {
        wrapperDOMElem: DOMElem,
        tooltip: this.createTooltip(DOMElem)
      };
    });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (this.props.theme.deviceType !== nextProps.theme.deviceType) {
      this.clearEvents(this.isMobile());
      this.restoreEvents(!this.isMobile());
    }
    return true;
  };

  clearEvents = isMobile => {
    const prevTypeEvent = isMobile ? 'mouseenter' : 'click';
    this.providerToggleTooltip(false, this.typeTooltip);
    const DOMelem = this.state.wrapperDOMElem;
    DOMelem && DOMelem.removeEventListener(prevTypeEvent, this.toggleTooltip(true));
    DOMelem && DOMelem.removeEventListener('mouseleave', this.toggleTooltip(false));
  };
  restoreEvents = isMobile => {
    const DOMelem = this.state.wrapperDOMElem;
    const typeEvent = isMobile ? 'click' : 'mouseenter';
    DOMelem.addEventListener(typeEvent, this.toggleTooltip(true));
    !isMobile && DOMelem.addEventListener('mouseleave', this.toggleTooltip(false));
  };

  componentWillUnmount = () => {
    this.clearEvents(this.isMobile());
  };

  render() {
    const { children } = this.props;
    return (
      <React.Fragment>
        {React.cloneElement(children, {
          ref: this.callBackBindButton
        })}
      </React.Fragment>
    );
  }
};

export default compose(
  showPopover,
  PropertyManager([
    'alt',
    'button',
    'typeTooltip',
    'toggleModal',
    'family',
    'hideTooltip',
    'popoverGetter',
    'popover',
    'popoverStyle',
    'posY',
    'posX',
    'bottomLimit',
    'disabled',
    'avoidPointer',
    'pointerStyle',
    'autoCloseTimeout',
    'removeTooltipTimeout',
    'onlyCloseByButton',
    'enablePropagation',
    'children'
  ]),
  withThemeJSS({ styleFile })
)(TooltipWrapper);
